import { render, staticRenderFns } from "./SegmentStep.vue?vue&type=template&id=1be50abf&scoped=true&"
import script from "./SegmentStep.vue?vue&type=script&lang=js&"
export * from "./SegmentStep.vue?vue&type=script&lang=js&"
import style0 from "./SegmentStep.vue?vue&type=style&index=0&id=1be50abf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be50abf",
  null
  
)

export default component.exports